import axios from 'axios';
import Qs from 'qs';
import store from '../store';

const REFRESH_TOKEN_URL = 'refresh-token';
const LOGIN_URL = 'login';

axios.defaults.baseURL = '/api';
// axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'indices' });
axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'repeat' });

// 自动刷新token
const refreshToken = cfg => new Promise((resolve, reject) => {
  axios.post(REFRESH_TOKEN_URL).then(() => {
    /* eslint-disable no-param-reassign */
    cfg.baseURL = '';
    cfg.headers.Authorization = `Bearer ${store.state.Auth.token}`;
    axios.request(cfg).then((newRequest) => {
      resolve(newRequest);
    });
  }, (error) => {
    store.commit('Auth/Logout'); // 刷新失败，就需要重新登录了
    reject(error);
  });
});

function refreshExpireToken(err) {
  return new Promise((resolve, reject) => refreshToken(err.config).then((newResponse) => {
    resolve(newResponse);
  }, reject));
}

// 添加请求拦截器
// 在发送请求前把token带上去
axios.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    if (window.localStorage.getItem('jwtToken') && config.headers.Authorization !== '') {
      // eslint-disable-next-line
      config.headers.common['Authorization'] = `Bearer ${window.localStorage.getItem('jwtToken')}`;
    }
    return config;
  },
  err => Promise.reject(err),
);

// 添加响应拦截器
// 遇到错误时的处理
axios.interceptors.response.use(
  (response) => {
    if (response.headers.authorization) {
      store.commit('Auth/SetToken', response.headers.authorization);
    }
    return response;
  },
  // 如果失败，看是不是需要自动刷新token
  (err) => {
    const orgRequest = err.config;
    if (err.response.status === 401
      && store.state.Auth.token
      && orgRequest.url.indexOf(REFRESH_TOKEN_URL) === -1
      && orgRequest.url.indexOf(LOGIN_URL) === -1) {
      return refreshExpireToken(err);
    }
    return Promise.reject(err);
  },
);

export default {
  install(Vue) {
    // eslint-disable-next-line
    Vue.prototype.$axios = Vue.axios = axios;
  },
};
